import React from "react";

// Minimalist 60+ Years badge — pure black & white, no gradients or laurels.
export default function YearsSeal({ size = 120, className = "" }) {
  return (
    <div className={`relative ${className}`} style={{ width: size, height: size }} data-testid="years-seal-svg">
      <svg viewBox="0 0 200 200" width={size} height={size}>
        <defs>
          <path id="seal-arc-outer" d="M 100,100 m -84,0 a 84,84 0 1,1 168,0 a 84,84 0 1,1 -168,0" />
        </defs>
        <circle cx="100" cy="100" r="96" fill="none" stroke="#0A0A0A" strokeWidth="1.5" />
        <circle cx="100" cy="100" r="80" fill="none" stroke="#0A0A0A" strokeWidth="0.5" />
        <text fill="#0A0A0A" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 700, letterSpacing: '6px' }} fontSize="9">
          <textPath href="#seal-arc-outer" startOffset="6%">CELEBRATING 60+ YEARS</textPath>
        </text>
        <text fill="#0A0A0A" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 700, letterSpacing: '6px' }} fontSize="9">
          <textPath href="#seal-arc-outer" startOffset="60%">SINCE 1964</textPath>
        </text>
        <text x="100" y="105" textAnchor="middle" fill="#0A0A0A"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 800, letterSpacing: '-0.04em' }} fontSize="56">60+</text>
        <text x="100" y="128" textAnchor="middle" fill="#525252"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, letterSpacing: '4px' }} fontSize="8">YEARS</text>
      </svg>
    </div>
  );
}
